import OnboardingScene from './OnboardingScene';
import { OnbBody, OnbButton, OnbError, OnbEyebrow, OnbGhostButton, OnbHeadline } from './OnboardingType';

// Screen 2 — Name. Confirmation/edit of the existing account name, never a parallel store.
// Desktop uses a boxed field with a visible label; mobile keeps the approved underline field.
export const StepName = ({ copy: COPY, value, onChange, onContinue, onBack, isSaving, error }) => {
  const submit = (e) => {
    e.preventDefault();
    onContinue();
  };

  return (
    <OnboardingScene
      step={2}
      copy={COPY}
      align="end"
      desktopAlign="center"
      objectClass="object-[62%_center] lg:object-center"
      onBack={onBack}
      hideFooterOnDesktop
      footer={
        <OnbButton onClick={onContinue} disabled={isSaving} testId="onboarding-continue-btn-2">
          {COPY.continue}
        </OnbButton>
      }
    >
      <form onSubmit={submit} className="max-w-[20rem] lg:ml-[12%] lg:max-w-[46rem] xl:ml-[14%]">
        <OnbEyebrow testId="onboarding-eyebrow-2" tight={COPY.tightEyebrow}>{COPY.name.eyebrow}</OnbEyebrow>
        <OnbHeadline testId="onboarding-headline-2">{COPY.name.headline}</OnbHeadline>
        <OnbBody className="mt-5 lg:mt-7">{COPY.name.support}</OnbBody>

        <label
          htmlFor="onboarding-name"
          className="sr-only lg:not-sr-only lg:mt-11 lg:block lg:text-[1rem] lg:text-white/70"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          {COPY.name.placeholder}
        </label>
        <input
          id="onboarding-name"
          name="name"
          type="text"
          autoComplete="given-name"
          maxLength={80}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={COPY.name.placeholder}
          className="mt-8 w-full border-b border-white/20 bg-transparent pb-3 text-[1.15rem] text-white/90 placeholder-white/30 transition-colors duration-300 focus:border-[#D4A843]/70 focus:outline-none lg:mt-4 lg:max-w-[34rem] lg:rounded-2xl lg:border lg:border-white/20 lg:bg-[#080D18]/70 lg:px-6 lg:py-5 lg:text-[1.35rem] lg:placeholder-white/25 lg:focus:border-[#D4A843]/70 lg:focus:bg-[#080D18]/85"
          style={{ fontFamily: '"Cormorant Garamond", Georgia, serif' }}
          data-testid="onboarding-name-input"
        />

        {error && <OnbError testId="onboarding-name-error">{error}</OnbError>}

        {/* Desktop: controls sit directly under the field, as approved. Mobile keeps the bottom bar. */}
        <div className="mt-11 hidden items-center gap-5 lg:flex">
          <OnbGhostButton onClick={onBack} testId="onboarding-back-btn-2-desktop">
            {COPY.back}
          </OnbGhostButton>
          <OnbButton onClick={onContinue} disabled={isSaving} testId="onboarding-continue-btn-2-desktop">
            {COPY.continue}
          </OnbButton>
        </div>

        <p
          className={`mt-10 uppercase text-white/25 lg:mt-12 lg:text-[11px] lg:tracking-[0.3em] ${COPY.tightEyebrow ? 'text-[8.5px] tracking-[0.18em]' : 'text-[9px] tracking-[0.24em]'}`}
          style={{ fontFamily: 'var(--font-display)' }}
          data-testid="onboarding-atmospheric-2"
        >
          {COPY.name.atmospheric}
        </p>
      </form>
    </OnboardingScene>
  );
};

export default StepName;
